import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {
  appointmentID = signal<number>(-1)
}
